/* eslint-disable */
export default {
  contactDetails: 'Detalhes de contato',
  loadingContact: 'Carregando contato...',
  contactNotFound: 'Contato não encontrado.',
} as const;

// @key: @#@"contactDetails"@#@ @source: @#@"Contact Details"@#@
// @key: @#@"loadingContact"@#@ @source: @#@"Loading contact..."@#@
// @key: @#@"contactNotFound"@#@ @source: @#@"Contact not found."@#@
